import {enumerate} from 'ts-transformer-enumerate';
import {keys} from 'ts-transformer-keys';

import {BaseRequestParameters} from '~/shared/src/model/BaseRequest';
import {
    LoadedItemData,
    LoadedReferenceData
} from '~/shared/src/utilities/loadedData';
import {Configs} from '~/shared/src/utilities/action';
import LocalizableError from '~/shared/src/base/LocalizableError';
import StackError from '~/shared/src/base/StackError';


type RequiredKeys<T> = { [K in keyof T]-? : {} extends Pick<T, K> ? never : K }[keyof T];
type RequiredOf<T> = Pick<T, RequiredKeys<T>>;


/*** config definitions ********************************************************************************************/

export type ParameterType = 'boolean' | 'itemsData' | 'itemsAndReferencesData' | 'number' | 'object' | 'referencesData' | 'string';
export const parameterTypes = enumerate<ParameterType>();


/*** MetaModel types *************************************************************************************************/

// CFG:BackendAction
export type BackendAction = {
    id : number;
    key : string;
    name? : string;

    function : string;
    order? : number;
    paramsWithType? : {
        [ parameterName : string ] : ParameterType;
    }
    groups : string[];
    user? : string;
    configs? : Configs;
};
export const requiredBackendActionProps = keys<RequiredOf<BackendAction>>();
export const backendActionProps = keys<BackendAction>();


/*** method types ****************************************************************************************************/

/*** execute ***/
export type ExecuteParameters = Partial<BaseRequestParameters> & {
    backendActionKey : string;
} & {
    [ parameterName : string ] : any;
};
export type ExecuteResult = {
    success : boolean;
    data : {
        items? : LoadedItemData[];
        references? : LoadedReferenceData[];
    } & {
        [ name : string ] : any;
    };
    metaData : {
        metrics : Metric[];
    } & {
        [ name : string ] : any;
    };
    error? : Error | LocalizableError | StackError | string
};
